
export default class Gamification {
    constructor() {
        this.version = "1.0.0.0";
        this.baseUrl = "https://gamification.jdsoftwarellc.com/";
        //this.baseUrl = "http://localhost:54223/"; 
        this.gameId = 6;

    }
    format(format) {
        var args = Array.prototype.slice.call(arguments, 1);
        return format.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != 'undefined'
                ? args[number]
                : match
                ;
        });
    };
    News(){
        let gameId = this.gameId;
        var url = this.baseUrl + `api/news/${gameId}`;
        return this.MakeRequest("GET", url);
    };
    ReportRankedGame(gameId, matchId, level, userId, opponentId, score, duration, tag) {
        //if undefined reutrn string
        if (!gameId || gameId == 0) gameId = this.gameId;
        if (!matchId || matchId == 0) matchId = "";
        if (!level || level == 0) level = 0;
        if (!userId || userId == 0) userId = "";
        if (!opponentId || opponentId == 0) opponentId = "";
        if (!score || score == 0) score = "";
        if (!duration || duration == 0) duration = 0;
        if (!tag || tag == 0) tag = "";

        score = Math.round(score);
        duration = Math.round(duration);

        var url = this.format("api/ranked/{0}?matchId={1}&level={2}&userId={3}&opponentId={4}&score={5}&duration={6}&tag={7}", gameId, matchId, level, userId, opponentId, score, duration, tag);
        //https://jimmyinteractive.com/Gamification/api/LeaderBoard?Id=3&matchId=3&level=3&userId=123&opponentId=123&score=1&duration=67&tag=html

        url = this.baseUrl + url;

        //send data
        return this.MakeRequest("GET", url);
    };
    Login(userdata, callback) {

        let email = userdata.email;
        let password = userdata.password;
        let facebookId = userdata.facebookId;
        let deviceId = userdata.deviceId;
        let name = userdata.name;
        let avatar = userdata.avatar;

        //if undefined or 0 return string

        if (!email) email = "";
        if (!password) password = "";
        if (!facebookId) facebookId = "";
        if (!deviceId) deviceId = "";
        if (!name) name = "";
        if (!avatar) avatar = "";

        var url = this.baseUrl + "api/Authentication";

        var postData = this.format("email={0}&password={1}&facebookId={2}&deviceId={3}&name={4}&avatar={5}", email, password, facebookId, deviceId, name, avatar);

        return this.MakeRequest("POST", url, postData, "application/x-www-form-urlencoded")
            .then(function (rawData) {
                let data = JSON.parse(rawData);
                return data;
            });
    };
    UploadAvatarUrl(id,imageUrl, callback) {
        // send image url avatar

        var url = this.baseUrl + `api/Avatar/${id}?url=${encodeURIComponent(imageUrl)}`;
        
        return this.MakeRequest("POST", url, null, undefined)
            .then(function (rawData) {
                let data = JSON.parse(rawData);
                return data;
            });
    };
    UploadAvatar(id,imageFile,imageUrl, callback) {
        //upload avatar 

        var url = this.baseUrl + `api/Avatar/${id}`;
        var postData = new FormData();
        /* Add the file */ 
        postData.append("upload",imageFile, imageFile.name);

        return this.MakeRequest("POST", url, postData, undefined)
            .then(function (rawData) {
                let data = JSON.parse(rawData);
                return data;
            });
    };
    UpdateUser(userdata, callback) {

        let id = userdata.id;
        let name = userdata.name;
        let deviceId = userdata.deviceId;
        let facebookId = userdata.facebookId;
        let avatar = encodeURIComponent(userdata.avatar);
        let email = userdata.email;

        //if undefined or 0 return string
        if (!id || id == 0) id = "";
        if (!name || name == 0) name = "";
        if (!deviceId || deviceId == 0) deviceId = "";
        if (!facebookId || facebookId == 0) facebookId = "";
        if (!avatar || avatar == 0) avatar = "";
        if (!email || email == 0) email = "";

        //clear device Id
        deviceId = "";

        var url = this.baseUrl + "api/User";

        var postData = this.format("Id={0}&name={1}&deviceId={2}&facebookId={3}&avatar={4}&email={5}", id, name, deviceId, facebookId, avatar, email);

        return this.MakeRequest("POST", url, postData, "application/x-www-form-urlencoded")
            .then(function (rawData) {
                let data = JSON.parse(rawData);
                return data;
            });
    };
    GetUser(id, gameId) {
        if (!gameId && gameId != 0) gameId = this.gameId;
        if (!id) return Promise.reject("no user id");
        var url = this.format("api/User/{0}?gameId={1}", id, gameId);
        var url = this.baseUrl + url;

        //send data
        return this.MakeRequest("GET", url).then(function (data) {
            return JSON.parse(data);
        });
    };
    FindUser(id, userName, email, deviceId, facebookId, callback) {
        //if undefined reutrn string
        if (!id && id != 0) id = "";
        if (!userName && userName != 0) userName = "";
        if (!email && email != 0) email = "";
        if (!deviceId && deviceId != 0) deviceId = "";
        if (!facebookId && facebookId != 0) facebookId = "";
        var url = this.format("api/User/?id={0}&userName={1}&email={2}&deviceId={3}&facebookId={4}", id, userName, email, deviceId, facebookId);
        var url = this.baseUrl + url;

        //send data
        return this.MakeRequest("GET", url).then(function (data) {
            data = JSON.parse(data);
            if (data && data.length > 0) data = data[0];
            else data = null;
            return data;
        });
    };
    GetLeaderBoard(gameId, league, fetchcount) {
        //if undefined reutrn string
        if (!gameId && gameId != 0) gameId = this.gameId;
        //if (!league) league = "Bronze";
        if (!league) league = "";
        if (!fetchcount) fetchcount = 50;
        var random = Math.floor(Math.random() * 1000000000);
        var url = this.format("api/LeaderBoard/{0}?league={1}&fetchcount={2}&random={3}", gameId, league, fetchcount, random);
        url = this.baseUrl + url;


        //send data
        return this.MakeRequest("GET", url).then(function (data) {
            return JSON.parse(data);
        });

    };
    GetGameHistory(userId,gameId) {
        //if undefined reutrn string
        if (!gameId && gameId != 0) gameId = this.gameId;
        var random = Math.floor(Math.random() * 1000000000);
        var url = this.format("api/GameHistory/{0}?gameId={1}&random={2}",userId, gameId, random);
        url = this.baseUrl + url;


        //send data
        return this.MakeRequest("GET", url).then(function (data) {
            return JSON.parse(data);
        });

    };
    GetGameServers(gameId) {

        //if undefined return string
        if (!gameId && gameId != 0) gameId = this.gameId;

        var url = this.format("api/GameServer/{0}", gameId);
        url = this.baseUrl + url;

        return this.MakeRequest("GET", url).then(function (data) {
            return JSON.parse(data);
        });
    };
    MakeRequest(method, url, data, ContentType) {
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open(method, url);
            xhr.setRequestHeader("cache-control", "private");
            if (ContentType) xhr.setRequestHeader("Content-type", ContentType);
            xhr.onload = function () {
                if (this.status >= 200 && this.status < 300) {
                    // var returnData = JSON.parse(xhr.responseText);
                    resolve(xhr.responseText);
                } else {
                    reject({
                        status: this.status,
                        statusText: xhr.statusText
                    });
                }
            };
            xhr.onerror = function () {
                reject({url:url,
                    status: this.status,
                    statusText: xhr.statusText
                });
            };
            if (!data)
                xhr.send();
            else
                xhr.send(data);
        });
    };
    InviteSend(username, toUserId, room, server) {
        var gameId = this.gameId;
        if (!server) server = "";

        var url = this.format("api/Invite?gameId={0}&userName={1}&userId={2}&room={3}&server={4}", gameId, username, toUserId, room, server);
        url = this.baseUrl + url;

        return this.MakeRequest("POST", url)
        .then(function (sent) {
            return JSON.parse(sent);
        })
    }

    NotificationSend(toUserId, message, callback) {
        var gameId = this.gameId;
        var url = this.format("api/Notifications/{0}?userId={1}", gameId, toUserId);
        url = this.BaseUrl + url;
        let data = JSON.stringify(message);

        return this.MakeRequest("POST", url,data)
        .then(function (sent) {
            return JSON.parse(sent);
        });
    }
    RegisterNotificationFCM (userId, token, deviceId) {
        var gameId = this.gameId;
        //check input parameters/data
        if (!userId) return Promise.reject(new Error('no user id'));
        if (!token) return Promise.reject(new Error('no token'));
        
        var data = {
            "userId": userId,
            "gameId": gameId,
            "token": token,
            "deviceId": deviceId
        };
        
        var url = this.format("api/NotificationRegisterFCM/{0}", userId);
        url =this.baseUrl + url;
    
        return this.MakeRequest("POST", url, JSON.stringify(data),"application/json");
    }
    RegisterNotification(PNS, azureRowId, handle, userId, callback) {

        if (!azureRowId || azureRowId < 0) azureRowId = this.GetDeviveID();
        var gameId = this.gameId;

        var url = this.format("api/NotificationRegister/{0}?gameId={1}", azureRowId, gameId);
        url = this.baseUrl + url;

        var xhr = new XMLHttpRequest();
        xhr.open('POST', url, this);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onload = function () {
            if (xhr.status === 200) {
                console.log('registerNotification responseText: ' + xhr.responseText);
                var data = JSON.parse(xhr.responseText);
                if (callback) callback(data);
            }
            else if (xhr.status !== 200) {
                console.log('registerNotification responseText: Request failed.  Returned status of ' + xhr.status);
                if (callback) callback(null);
            }
        };
        var body = JSON.stringify({
            "Platform": PNS,
            "Handle": handle,
            "Tags": [
                "userid:" + userId
            ]
        });

        xhr.send(body);
    }
    GetUserData(userId, gameId) {

        if (!gameId && gameId != 0) gameId = this.gameId;
        //check input parameters
        if (!userId) return Promise.reject("no user id");

        var url = this.format("api/UserData/{0}?gameId={1}", userId, gameId);
        url = this.baseUrl + url;

        return this.MakeRequest("GET", url).then(function (data) {
            return JSON.parse(data);
        });
    };

    SaveUserData(userId, data, gameId) {
        if (!gameId && gameId != 0) gameId = this.gameId;
        //check input parameters/data
        if (!userId) return Promise.reject(new Error('no user id'));
        if (!data) return Promise.reject(new Error('no user data'));

        var url = this.format("api/UserData/{0}?gameId={1}", userId, gameId);
        url = this.baseUrl + url;

        return this.MakeRequest("POST", url, JSON.stringify(data));
    };
    GetBlacklist(gameId) {
        if (!gameId && gameId != 0) gameId = this.gameId;

        var url = `api/Blacklist/${gameId}`;
        url = this.baseUrl + url;

        return this.MakeRequest("GET", url).then(function (data) {
            return JSON.parse(data);
        });
    };
    StorageAvailable(type) {
        try {
            var storage = window[type],
                x = '__storage_test__';
            storage.setItem(x, x);
            storage.removeItem(x);
            return true;
        }
        catch(e) {
            return false;
        }
    };
    GetDeviveID() {
        let uuid = null;

        // //try using cordova
        // if (typeof device !== "undefined" && device.uuid !== "undefined") {
        //     uuid = device.uuid;
        // }

        //if device id not exist create one and save it
        if (uuid === null && this.StorageAvailable('localStorage')) {
            uuid = localStorage.getItem("uuid");
            if (uuid === null) {
                uuid = Math.floor(Math.random() * (99999999 - 10000000 + 1)) + 10000000;//get random number:Math.floor(Math.random() * (max - min + 1)) + min;
                localStorage.setItem('uuid', uuid);
            }
        }
        //else just give it an id
        if (uuid === null) {
            uuid = Math.floor(Math.random() * (99999999 - 10000000 + 1)) + 10000000;//get random number:Math.floor(Math.random() * (max - min + 1)) + min;
        }

        return uuid;

    }
}
